<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    title="已报废列表"
    size="640px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <el-form
        label-width="85px"
        @submit.native.prevent>
        <el-row
          :gutter="8"
          type="flex">
          <el-col :span="12">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">刷新</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="开始序号"
          min-width="180"
          prop="beginTagNo">
          <template slot-scope="{ row }">{{ row.beginTagNo | tagCount() }}</template>
        </el-table-column>
        <el-table-column
          label="结束序号"
          min-width="180"
          prop="endTagNo">
          <template slot-scope="{ row }">{{ row.endTagNo | tagCount() }}</template>
        </el-table-column>
        <el-table-column
          label="标签数量"
          width="90"
          prop="tagCount"></el-table-column>
        <!-- <el-table-column
          label="操作"
          fixed="right"
          width="80">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="scraptags(row)">立即报废</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </div>
  </el-drawer>
</template>

<script>
import AppraiseLable from '@/service/appraiseLable'
export default {
  name: 'LabelScrappedModal',
  components: { },
  data() {
    return {
      visible: false,
      loading: false,
      config: { pageNum: 1, pageSize: 10, tagSegId: null },
      total: 0,
      list: []
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.list = []
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      AppraiseLable.gettagscrappeds({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(row) {
      this.visible = true
      this.config = { ...this.config, ...row }
      this.fetchList()
    }
  }
}
</script>
